import React, { useState, useRef } from "react";
import { Box, Button, Checkbox, FormControlLabel, Menu, MenuItem } from "@mui/material";

const styles = {
  menuButton: {
    textTransform: "none",
    letterSpacing: 0,
  },
  menuItem: {
    padding: 0,
  },
  formControlLabel: theme => ({
    padding: theme.spacing(0.5, 2),
    width: "100%",
    margin: 0,
  }),
};

const MultiSelect = ({ onClose, label, options, value, onChange, disabled, ...props }) => {
  const anchorRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);

  const handleMenuOpen = () => {
    setOpenMenu(true);
  };

  const handleMenuClose = () => {
    setOpenMenu(false);
    if (onClose) {
      onClose();
    }
  };

  const handleOptionToggle = event => {
    let newValue = [...value];

    if (event.target.checked) {
      newValue.push(event.target.value);
    } else {
      newValue = newValue.filter(item => item !== event.target.value);
    }

    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <Box {...props}>
      <Button
        fullWidth
        sx={styles.menuButton}
        aria-haspopup="true"
        disabled={disabled}
        onClick={handleMenuOpen}
        ref={anchorRef}
      >
        {label}
      </Button>
      <Menu anchorEl={anchorRef.current} elevation={1} onClose={handleMenuClose} open={openMenu}>
        {options.map((option, index) => (
          <MenuItem sx={styles.menuItem} key={`${index}-${label}`} data-id="select-item">
            <FormControlLabel
              sx={styles.formControlLabel}
              control={
                <Checkbox
                  disabled={disabled}
                  checked={value.indexOf(option[0]) > -1}
                  onChange={handleOptionToggle}
                  value={option[0]}
                />
              }
              label={option[1]}
            />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default MultiSelect;
